import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';


interface Props {
    seconds: number;
    height?: number;
    widthPercentage?: number;
    onTimeout: () => void;
}

export const LinearCountdown = (props: Props) => {
    const [secondsLeft, setSecondsLeft] = React.useState(props.seconds);
    const [progress, setProgress] = React.useState(100);
    const lineHeight = props.height ?? 10;
    const lineWidth = `${props.widthPercentage ?? 110}%`;

    React.useEffect(() => {
        const timer = setInterval(() => {
            if (secondsLeft <= 0) {
                clearInterval(timer);
                props.onTimeout();
                return;
            }
            const currentSecLeft = secondsLeft - 0.5;
            setSecondsLeft(currentSecLeft);
            setProgress((currentSecLeft / props.seconds) * 100);
        }, 500);
        return () => {
            clearInterval(timer);
        };
    }, [props, secondsLeft]);

    function getLineColor(progress: number): 'error' | 'info' | 'success' | 'warning' {
        if (progress > 75) {
            return 'success';
        }
        if (progress > 50) {
            return 'info';
        }
        if (progress > 25) {
            return 'warning';
        }
        return 'error';
    }

    return (
        <Box sx={{ width: lineWidth }}>
            <LinearProgress variant="determinate" value={progress} color={getLineColor(progress)} sx={{minHeight: lineHeight}}/>
        </Box>
    );
};
